export default class Popups{
    
    constructor(){
        this.popups = document.querySelectorAll('.popup');
        this.popupOpens = document.querySelectorAll('.popup-open');
        this.popupCloses = document.querySelectorAll('.popup__close');
        this.openedPopups;
        this.init();

    }
    
    init(){

        if(this.popupOpens){
            this.popupOpens.forEach((btn)=>{
                let popup;
                if (btn.dataset.target){
                    popup = document.querySelector(btn.dataset.target);
                }else{
                    popup = btn.querySelector('.popup');
                }
                console.log(popup);
                if (popup){
                    btn.addEventListener('click', (e) => {
                        popup.classList.add('active');
                        document.body.classList.add('popup-opened');
                    });
                    this.openedPopup = popup;
                }
            });
        }

        if(this.popupCloses){
            this.popupCloses.forEach((btn)=>{
                let popup = btn.closest('.popup');
                if (popup){
                    btn.addEventListener('click', (e) => {
                        e.stopImmediatePropagation();
                        this.closePopup(popup);
                    });
                }
            });
        }

        
        
    }

    closePopup(popup){
        popup.classList.remove('active');
        document.body.classList.remove('popup-opened');
    }
}